import RevenueChart from './RevenueChart';

export default RevenueChart;
